module.exports = __webpack_public_path__ + "img/zichanyunying.d47b37f7.png";